import Vue from "vue";
import NavBar from "@/components/NavBar.vue";
import MonthlyProgress from "@/components/dashboard/MonthlyProgress.vue";
import ModalTrigger from "@/components/modal/ModalTrigger.vue";
import TaxYearSummary from "@/components/dashboard/TaxYearSummary.vue";
import LatestTransactions from "@/components/dashboard/LatestTransactions.vue";
import TransactionEntry from "@/components/balances/TransactionEntry.vue";
import RecurringTransactionEntry from "@/components/balances/RecurringTransactionEntry.vue";
import AmountInput from "@/components/input/AmountInput.vue";
import BalanceEntry from "@/components/balances/BalanceEntry.vue";
import TextInput from "@/components/input/TextInput.vue";
import DateInput from "@/components/input/DateInput.vue";
import SelectInput from "@/components/input/SelectInput.vue";
import FileInput from "@/components/input/FileInput.vue";
import NumberInput from "@/components/input/NumberInput.vue";
import BalanceTable from "@/components/balances/BalanceTable.vue";
import ConfirmationModal from "@/components/modal/ConfirmationModal.vue";
import NotificationMessage from "@/components/messages/NotificationMessage.vue";
import RecurringBalanceEntry from "@/components/balances/RecurringBalanceEntry.vue";
import PricingOptionCard from "@/components/pricing/PricingOptionCard.vue";
import FeatureList from "@/components/util/FeatureList.vue";
import LineChart from "@/components/reports/LineChart.vue";
import StackedChart from "@/components/reports/StackedChart.vue";
import IncomeSourcesChart from "@/components/reports/IncomeSourcesChart.vue";
import PricingTable from "@/components/pricing/PricingTable.vue";
import PricingTableLanding from "@/components/pricing/PricingTableLanding.vue";
import Testimonials from "@/components/landing/Testimonials.vue";
import FeatureScreenshot from "@/components/landing/FeatureScreenshot.vue";
import MoneyBackGuarantee from "@/components/pricing/MoneyBackGuarantee.vue";
import RegisterForm from "@/components/auth/RegisterForm.vue";
import TaxLiability from "@/components/reports/TaxLiability.vue";
import TaxReturnPicker from "@/components/tax/TaxReturnPicker.vue";
import BasicAccountDetails from "@/components/account/BasicAccountDetails.vue";
import DropdownMenu from "@/components/util/DropdownMenu.vue";
import BasicTaxDetailsForm from "@/components/tax/BasicTaxDetailsForm.vue";
import GenericTaxDetailsForm from "@/components/tax/GenericTaxDetailsForm.vue";
import TaxReturnNav from "@/components/tax/TaxReturnNav.vue";
import ToggleInput from "@/components/input/ToggleInput.vue";
import VehicleDetailsForm from "@/components/tax/VehicleDetailsForm.vue";
import TaxReturnProgress from "@/components/tax/TaxReturnProgress.vue";
import EmploymentDetailsForm from "@/components/tax/EmploymentDetailsForm.vue";
import BalancingPaymentForm from "@/components/tax/BalancingPaymentForm.vue";
import TaxReturnResult from "@/components/tax/TaxReturnResult.vue";
import UserTaxDetails from "@/components/account/UserTaxDetails.vue";
import EmailOptInOffer from "@/components/landing/EmailOptInOffer.vue";
import CopyToClipboard from "@/components/util/CopyToClipboard";
import SubscriptionForm from "@/components/subscription/SubscriptionForm.vue";

import VTooltip from 'v-tooltip';
import vSelect from 'vue-select';
import {DatePicker} from 'v-calendar';
import HoneybadgerVue from '@honeybadger-io/vue';

import PortalVue from "portal-vue";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {library} from "@fortawesome/fontawesome-svg-core";
import {faPlus} from "@fortawesome/pro-solid-svg-icons/faPlus";
import {faArrowRight} from "@fortawesome/pro-light-svg-icons/faArrowRight";
import {faArrowLeft} from "@fortawesome/pro-light-svg-icons/faArrowLeft";
import {faRepeat} from "@fortawesome/pro-solid-svg-icons/faRepeat";
import {faChartBar} from "@fortawesome/pro-solid-svg-icons/faChartBar";
import {faCreditCard} from "@fortawesome/pro-solid-svg-icons/faCreditCard";
import {faCalendarDay} from "@fortawesome/pro-solid-svg-icons/faCalendarDay";
import {faShoppingCart} from "@fortawesome/pro-solid-svg-icons/faShoppingCart";
import {faCog} from "@fortawesome/pro-solid-svg-icons/faCog";
import {faTimes} from "@fortawesome/pro-regular-svg-icons/faTimes";
import {faTimes as faTimesSolid} from "@fortawesome/pro-solid-svg-icons/faTimes";
import {faFilePlus} from "@fortawesome/pro-solid-svg-icons/faFilePlus";
import {faFilePdf} from "@fortawesome/pro-solid-svg-icons/faFilePdf";
import {faFileExcel} from "@fortawesome/pro-solid-svg-icons/faFileExcel";
import {faFileImage} from "@fortawesome/pro-solid-svg-icons/faFileImage";
import {faFile} from "@fortawesome/pro-solid-svg-icons/faFile";
import {faTrash} from "@fortawesome/pro-solid-svg-icons/faTrash";
import {faInfoCircle} from "@fortawesome/pro-solid-svg-icons/faInfoCircle";
import {faCheckCircle} from "@fortawesome/pro-solid-svg-icons/faCheckCircle";
import {faRedo} from "@fortawesome/pro-regular-svg-icons/faRedo";
import {faUser} from "@fortawesome/pro-solid-svg-icons/faUser";
import {faPlayCircle} from "@fortawesome/pro-solid-svg-icons/faPlayCircle";
import {faTimesCircle} from "@fortawesome/pro-solid-svg-icons/faTimesCircle";
import {faChevronLeft} from "@fortawesome/pro-solid-svg-icons/faChevronLeft";
import {faChevronRight} from "@fortawesome/pro-solid-svg-icons/faChevronRight";
import {faChevronUp} from "@fortawesome/pro-solid-svg-icons/faChevronUp";
import {faUserCircle} from "@fortawesome/pro-solid-svg-icons/faUserCircle";
import {faQuestionCircle} from "@fortawesome/pro-solid-svg-icons/faQuestionCircle";
import {faFolderOpen} from "@fortawesome/pro-solid-svg-icons/faFolderOpen";
import {faLock} from "@fortawesome/pro-solid-svg-icons/faLock";
import {faCopy} from "@fortawesome/pro-solid-svg-icons/faCopy";

library.add(faPlus, faArrowRight, faArrowLeft, faRepeat, faChartBar, faCreditCard, faCalendarDay,
    faShoppingCart, faCog, faTimes, faFilePlus, faTimesSolid, faFilePdf, faFileExcel, faFileImage, faFile, faTrash,
    faInfoCircle, faRedo, faCheckCircle, faUser, faPlayCircle, faTimesCircle, faChevronLeft, faChevronRight, faUserCircle,
    faQuestionCircle, faChevronUp, faFolderOpen, faLock, faCopy);

Vue.use(PortalVue);
Vue.use(VTooltip);
if (process.env.NODE_ENV !== 'development') {
    Vue.use(HoneybadgerVue as any, {
        apiKey: process.env.MIX_HONEYBADGER_API_KEY,
        environment: process.env.MIX_HONEYBADGER_ENVIRONMENT,
        revision: process.env.MIX_HONEYBADGER_REVISION
    });
}

Vue.component('nav-bar', NavBar);
Vue.component('copy-to-clipboard', CopyToClipboard);
//@ts-ignore
Vue.component('v-select', vSelect);
Vue.component('monthly-progress', MonthlyProgress);
Vue.component('modal-trigger', ModalTrigger);
Vue.component('tax-year-summary', TaxYearSummary);
Vue.component('latest-transactions', LatestTransactions);
Vue.component('transaction-entry', TransactionEntry);
Vue.component('recurring-transaction-entry', RecurringTransactionEntry);
Vue.component('amount-input', AmountInput);
Vue.component('number-input', NumberInput);
Vue.component('text-input', TextInput);
Vue.component('date-input', DateInput);
Vue.component('file-input', FileInput);
Vue.component('select-input', SelectInput);
Vue.component('toggle-input', ToggleInput);
Vue.component('balance-entry', BalanceEntry);
Vue.component('recurring-balance-entry', RecurringBalanceEntry);
Vue.component('date-picker', DatePicker);
Vue.component('balance-table', BalanceTable);
Vue.component('confirmation-modal', ConfirmationModal);
Vue.component('notification-message', NotificationMessage);
Vue.component('pricing-option-card', PricingOptionCard);
Vue.component('pricing-table', PricingTable);
Vue.component('pricing-table-landing', PricingTableLanding);
Vue.component('feature-list', FeatureList);
Vue.component('tax-liability', TaxLiability);
Vue.component('line-chart', LineChart);
Vue.component('stacked-chart', StackedChart);
Vue.component('income-sources-chart', IncomeSourcesChart);
Vue.component('testimonials', Testimonials);
Vue.component('feature-screenshot', FeatureScreenshot);
Vue.component('money-back-guarantee', MoneyBackGuarantee);
Vue.component('register-form', RegisterForm);
Vue.component('subscription-form', SubscriptionForm);
Vue.component('tax-return-picker', TaxReturnPicker);
Vue.component('basic-account-details', BasicAccountDetails);
Vue.component('user-tax-details', UserTaxDetails);
Vue.component('basic-tax-details-form', BasicTaxDetailsForm);
Vue.component('generic-tax-details-form', GenericTaxDetailsForm);
Vue.component('vehicle-details-form', VehicleDetailsForm);
Vue.component('employment-details-form', EmploymentDetailsForm);
Vue.component('dropdown-menu', DropdownMenu);
Vue.component('tax-return-nav', TaxReturnNav);
Vue.component('tax-return-progress', TaxReturnProgress);
Vue.component('balancing-payment-form', BalancingPaymentForm);
Vue.component('tax-return-result', TaxReturnResult);
Vue.component('email-opt-in-offer', EmailOptInOffer);
Vue.component('font-awesome-icon', FontAwesomeIcon);

new Vue({
    el: '#app',

    mounted() {
        if (process.env.NODE_ENV !== 'development') {
            this.$honeybadger.setContext({userId: (window as any).USER_ID});
        }
    }
});

(window as any).axios = require('axios');